/* one% header: translucent-on-scroll, cart badge (onepercent:cart), disclosure menus. */
(function () {
  // Shared in-page anchor scroll (-56px, smooth). Also in op-announcement.js / op-hero.js; runs once.
  if (!window.__opAnchorScroll) {
    window.__opAnchorScroll = true;
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[data-op-scroll]') : null;
      if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var url;
      try { url = new URL(a.getAttribute('href'), window.location.href); } catch (err) { return; }
      if (!url.hash || url.pathname !== window.location.pathname) return;
      var el = document.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (!el) return;
      e.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var y = el.getBoundingClientRect().top + window.scrollY - 56;
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  if (customElements.get('op-header')) return;

  class OpHeader extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.op-header') || this;
      this.scrolled = null;

      this.onScroll = () => {
        const s = window.scrollY > 40;
        if (s !== this.scrolled) {
          this.scrolled = s;
          this.root.classList.toggle('is-scrolled', s);
        }
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();

      this.onCart = (e) => {
        const n = e.detail && typeof e.detail.count === 'number' ? e.detail.count : null;
        if (n !== null) this.setCount(n, true);
      };
      window.addEventListener('onepercent:cart', this.onCart);

      // Back/forward cache can restore a stale badge: re-read the cart.
      this.onPageShow = (e) => {
        if (e.persisted && window.OnePercentCart) {
          window.OnePercentCart.count().then((n) => this.setCount(n, false)).catch(() => {});
        }
      };
      window.addEventListener('pageshow', this.onPageShow);

      this.details = Array.from(this.querySelectorAll('details'));
      this.onDocClick = (e) => {
        this.details.forEach((d) => { if (d.open && !d.contains(e.target)) d.open = false; });
      };
      document.addEventListener('click', this.onDocClick);

      this.onKey = (e) => {
        if (e.key !== 'Escape') return;
        const open = this.details.find((d) => d.open);
        if (!open) return;
        open.open = false;
        const s = open.querySelector('summary');
        if (s) s.focus();
      };
      this.addEventListener('keydown', this.onKey);

      this.details.forEach((d) => {
        d.addEventListener('toggle', () => {
          if (d.open) this.details.forEach((o) => { if (o !== d && o.open) o.open = false; });
        });
      });
      this.querySelectorAll('.op-header__menu-panel a').forEach((a) => {
        a.addEventListener('click', () => {
          const d = a.closest('details');
          if (d) d.open = false;
        });
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('onepercent:cart', this.onCart);
      window.removeEventListener('pageshow', this.onPageShow);
      document.removeEventListener('click', this.onDocClick);
      clearTimeout(this.popT);
    }

    setCount(n, pop) {
      const count = Math.max(0, Number(n) || 0);
      const badge = this.querySelector('[data-op-cart-count]');
      const link = this.querySelector('[data-op-cart]');
      if (badge) {
        badge.textContent = String(count);
        badge.hidden = count === 0;
        if (pop && count > 0) {
          badge.classList.add('is-pop');
          clearTimeout(this.popT);
          this.popT = setTimeout(() => badge.classList.remove('is-pop'), 260);
        }
      }
      if (link) {
        const t = link.getAttribute('data-label-template');
        if (t) link.setAttribute('aria-label', t.replace('[count]', String(count)));
      }
    }
  }

  customElements.define('op-header', OpHeader);
})();
